import React from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  return <div className="my-16" data-id="element-78">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-79">
        How LyraSleep Compares
      </h2>

      <div className="overflow-x-auto" data-id="element-80">
        <table className="w-full border-collapse bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-81">
          <thead data-id="element-82">
            <tr className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white" data-id="element-83">
              <th className="p-4 text-left font-semibold" data-id="element-84">Feature</th>
              <th className="p-4 text-center font-semibold bg-purple-700" data-id="element-85">
                LyraSleep
              </th>
              <th className="p-4 text-center font-semibold" data-id="element-86">Melatonin</th>
              <th className="p-4 text-center font-semibold" data-id="element-87">Ambien</th>
              <th className="p-4 text-center font-semibold" data-id="element-88">Tylenol PM</th>
            </tr>
          </thead>
          <tbody data-id="element-89">
            <tr className="border-b border-gray-200" data-id="element-90">
              <td className="p-4 font-medium text-gray-900" data-id="element-91">
                Addresses Root Cause
              </td>
              <td className="p-4 text-center bg-green-50" data-id="element-92">
                <div className="flex flex-col items-center gap-1" data-id="element-93">
                  <Check className="w-6 h-6 text-green-600" data-id="element-94" />
                  <span className="text-xs text-gray-600" data-id="element-95">(anxiety)</span>
                </div>
              </td>
              <td className="p-4 text-center" data-id="element-96">
                <div className="flex flex-col items-center gap-1" data-id="element-97">
                  <X className="w-6 h-6 text-red-600" data-id="element-98" />
                  <span className="text-xs text-gray-600" data-id="element-99">(timing only)</span>
                </div>
              </td>
              <td className="p-4 text-center" data-id="element-100">
                <div className="flex flex-col items-center gap-1" data-id="element-101">
                  <X className="w-6 h-6 text-red-600" data-id="element-102" />
                  <span className="text-xs text-gray-600" data-id="element-103">
                    (forces unconscious)
                  </span>
                </div>
              </td>
              <td className="p-4 text-center" data-id="element-104">
                <div className="flex flex-col items-center gap-1" data-id="element-105">
                  <X className="w-6 h-6 text-red-600" data-id="element-106" />
                  <span className="text-xs text-gray-600" data-id="element-107">(sedation)</span>
                </div>
              </td>
            </tr>

            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-108">
              <td className="p-4 font-medium text-gray-900" data-id="element-109">
                What Actually Happens
              </td>
              <td className="p-4 text-center bg-green-50" data-id="element-110">
                <span className="text-sm text-gray-800 font-medium" data-id="element-111">
                  Fall asleep in 20 min, sleep 7+ hours, wake clear
                </span>
              </td>
              <td className="p-4 text-center" data-id="element-112">
                <span className="text-sm text-gray-800" data-id="element-113">
                  Groggy mess, still awake at 3AM
                </span>
              </td>
              <td className="p-4 text-center" data-id="element-114">
                <span className="text-sm text-gray-800" data-id="element-115">
                  "Works" but terrified of dementia
                </span>
              </td>
              <td className="p-4 text-center" data-id="element-116">
                <span className="text-sm text-gray-800" data-id="element-117">
                  Brain fog, dependency
                </span>
              </td>
            </tr>

            <tr className="border-b border-gray-200" data-id="element-118">
              <td className="p-4 font-medium text-gray-900" data-id="element-119">Morning Clarity</td>
              <td className="p-4 text-center bg-green-50" data-id="element-120">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-121" />
              </td>
              <td className="p-4 text-center" data-id="element-122">
                <span className="text-sm text-gray-600" data-id="element-123">Grogginess</span>
              </td>
              <td className="p-4 text-center" data-id="element-124">
                <span className="text-sm text-gray-600" data-id="element-125">Hangover</span>
              </td>
              <td className="p-4 text-center" data-id="element-126">
                <span className="text-sm text-gray-600" data-id="element-127">Brain fog</span>
              </td>
            </tr>

            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-128">
              <td className="p-4 font-medium text-gray-900" data-id="element-129">
                Non-Habit Forming
              </td>
              <td className="p-4 text-center bg-green-50" data-id="element-130">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-131" />
              </td>
              <td className="p-4 text-center" data-id="element-132">
                <span className="text-sm text-gray-600" data-id="element-133">Dependency</span>
              </td>
              <td className="p-4 text-center" data-id="element-134">
                <span className="text-sm text-gray-600" data-id="element-135">Addiction risk</span>
              </td>
              <td className="p-4 text-center" data-id="element-136">
                <span className="text-sm text-gray-600" data-id="element-137">Tolerance buildup</span>
              </td>
            </tr>

            <tr className="border-b border-gray-200" data-id="element-138">
              <td className="p-4 font-medium text-gray-900" data-id="element-139">No Prescription</td>
              <td className="p-4 text-center bg-green-50" data-id="element-140">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-141" />
              </td>
              <td className="p-4 text-center" data-id="element-142">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-143" />
              </td>
              <td className="p-4 text-center" data-id="element-144">
                <span className="text-sm text-gray-600" data-id="element-145">Requires doctor</span>
              </td>
              <td className="p-4 text-center" data-id="element-146">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-147" />
              </td>
            </tr>

            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-148">
              <td className="p-4 font-medium text-gray-900" data-id="element-149">Clinical Doses</td>
              <td className="p-4 text-center bg-green-50" data-id="element-150">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-151" />
              </td>
              <td className="p-4 text-center" data-id="element-152">
                <span className="text-sm text-gray-600" data-id="element-153">Weak</span>
              </td>
              <td className="p-4 text-center" data-id="element-154">
                <span className="text-sm text-gray-600" data-id="element-155">N/A</span>
              </td>
              <td className="p-4 text-center" data-id="element-156">
                <span className="text-sm text-gray-600" data-id="element-157">N/A</span>
              </td>
            </tr>

            <tr data-id="element-158">
              <td className="p-4 font-medium text-gray-900" data-id="element-159">
                Sleep Through Night
              </td>
              <td className="p-4 text-center bg-green-50" data-id="element-160">
                <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-161" />
              </td>
              <td className="p-4 text-center" data-id="element-162">
                <span className="text-sm text-gray-600" data-id="element-163">Wears off</span>
              </td>
              <td className="p-4 text-center" data-id="element-164">
                <span className="text-sm text-gray-600" data-id="element-165">Sometimes</span>
              </td>
              <td className="p-4 text-center" data-id="element-166">
                <span className="text-sm text-gray-600" data-id="element-167">Wears off</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}